export default "cc116f72a3684fd5.ttf"